module.exports = __webpack_public_path__ + "static/img/s177.549447c1.png";